import { withPrefix } from 'gatsby-link'

// sd for organisation should be present on every page
const getDefaultStructuredData = (siteUrl) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'AOK - Die Gesundheitskasse',
    'legalName': 'AOK - Die Gesundheitskasse',
    'url': 'https://www.aok.de/',
    'logo': `${siteUrl}${withPrefix('logo-aok-green.png')}`,
    'sameAs': ['https://www.kununu.com/de/aok-bundesverband'],
  }
}

export default getDefaultStructuredData

export const getPublisher = (siteUrl) => {
  return {
    name: 'AOK - Die Gesundheitskasse',
    logo: `${siteUrl}${withPrefix('logo-aok-green.png')}`,
    legalName: 'AOK - Die Gesundheitskasse',
    url: 'https://www.aok.de/',
    sameAs: ['https://www.kununu.com/de/aok-bundesverband'],
  }
}
